import { render, staticRenderFns } from "./elementCoursePriceEditor.vue?vue&type=template&id=2c0e41b3&scoped=true&"
import script from "./elementCoursePriceEditor.vue?vue&type=script&lang=js&"
export * from "./elementCoursePriceEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0e41b3",
  null
  
)

export default component.exports